import React from 'react';
import PropTypes from 'prop-types';
export var PanelSection = function PanelSection(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return React.createElement("div", {
    className: "searchbox__section"
  }, title && React.createElement("h4", null, title), React.createElement("ul", null, children));
};
PanelSection.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node
};